import { PolicyType } from '@aaa-ncnu-ie/mypolicy-api-customers';
import {
  AutoPolicy,
  PropertyPolicy,
  PupPolicy,
} from '@aaa-ncnu-ie/mypolicy-api-policies';
import { capitalize, Stack } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

import { usePolicyDetailsQuery } from '../../api/getPolicyDetails';
import useUpdateTitle from '../../hooks/useUpdateTitle';
import AutoPolicyDetails from './AutoPolicyDetails';
import PersonalUmbrellaPolicyDetails from './PersonalUmbrellaPolicyDetails';
import PropertyPolicyDetails from './PropertyPolicyDetails';
import CircularProgress from '../../components/CircularProgress/CircularProgress';

const PolicyDetails: React.FC = () => {
  const { policyNumber } = useParams<{ policyNumber: string }>();
  const { data, isLoading } = usePolicyDetailsQuery(policyNumber);
  const policyType = data?.policySummary.policyType
    ? data?.policySummary.policyType
        .split(' ')
        .map((name) => capitalize(name))
        .join(' ')
    : '';

  useUpdateTitle(`${policyType} Policy Details`);

  if (isLoading || !data?.policySummary)
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ width: 1 }}>
        <CircularProgress size={120} />
      </Stack>
    );

  const renderContent = () => {
    switch (data?.policySummary.policyType) {
      case PolicyType.AUTO:
      case PolicyType.MC:
        return (
          <AutoPolicyDetails
            autoPolicy={data as AutoPolicy}
            policyType={data.policySummary.policyType}
          />
        );
      case 'Personal umbrella':
        return <PersonalUmbrellaPolicyDetails pupPolicy={data as PupPolicy} />;
      case PolicyType.Property:
        return (
          <PropertyPolicyDetails propertyPolicy={data as PropertyPolicy} />
        );
      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};

export default PolicyDetails;
